import forEach from 'lodash/forEach';

const PREFIX = '@by-preset-';

export default function deletableMerge(oriObj, mergingObj) {
    oriObj = Object.assign({}, oriObj);
    mergingObj = Object.assign({}, mergingObj);

    forEach(oriObj, (value, key) => {
        if (key.indexOf(PREFIX) !== 0) {
            delete oriObj[key];
        }
    });

    return Object.assign({}, oriObj, mergingObj);
}
